//PLANTAS
export const PLANTAS_GET = "plantas";
export const PLANTAS_GET_COMBO = "plantas/list";

//BITACORA
export const BITACORA_POST_FILTER = "bitacora/filter";
export const BITACORA_POST_TABLE_FILTER = "bitacora/table/filter";
export const BITACORA_REPORTE = "reportes/bitacora";

// UTILERIAS 
export const GET_FECHAS_FOR_LIVE_SCREEN = "utilerias/getFechasForLiveScreen";

//LOGIN
export const GET_TOKEN_LOGIN = "login";

// CLIENTES
export const CLIENTE = "cliente";
export const CLIENTE_DASHBOARD = "catalogoClientes";

//LICENCIAS
export const LICENCIAS = "licenciamiento";
export const LICENCIAS_CLIENTE = "licenciamiento/cliente";
export const VIGENCIA = "vigencia";
export const LICENCIAS_CLIENTES_DASHBOARD = "configLicenciaFromCliente";

export const ROLES = "roles"
export const USUARIOS = "usuarios"

//--> Login
export const RECUPERAR_PASSWORD = "usuarios/recuperarPassword/save"
// export const RECUPERAR_PASSWORD = "/recuperarPassword/save"
export const RESET_PASSWORD = "usuarios/recuperarPassword"
